<template>
  <v-main>
    <v-breadcrumbs :items="breadcrumbs" v-if="breadcrumbs" />
    <transition :name="transition" mode="out-in">
      <router-view />
    </transition>
  </v-main>
</template>

<script>
import RouteMeta from '@/components/Mixins/RouteMeta';

export default {
  name: 'Layout',
  mixins: [
    RouteMeta,
  ],
  watch: {
    $route(to, from) {
      this.setBreadcrumbs();
      this.setTransition(to, from);
    },
  },
  mounted() {
    this.setBreadcrumbs();
  },
};
</script>
